import React from "react";
import styled from "styled-components";

interface FilterButtonsProps {
  filter: (category: string) => void;
  buttons: string[];
  activeFilter: string;
}

const FilterButtons: React.FC<FilterButtonsProps> = ({
  filter,
  buttons,
  activeFilter,
}) => {
  return (
    <ButtonsWrapper>
      {buttons.map((btn, i) => (
        <PillButton
          key={i}
          onClick={() => filter(btn)}
          className={activeFilter === btn ? "active" : ""}
        >
          {btn}
        </PillButton>
      ))}
    </ButtonsWrapper>
  );
};

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 2.5rem;
`;

const PillButton = styled.button`
  outline: none;
  border: 1px solid var(--border-color);
  background: transparent;
  padding: 0.5rem 1.25rem;
  font-size: 0.85rem;
  font-weight: 500;
  font-family: inherit;
  color: var(--font-light-color);
  cursor: pointer;
  border-radius: 100px;
  transition: all 0.25s ease;
  white-space: nowrap;

  &:hover {
    border-color: var(--primary-color);
    color: var(--primary-color);
    background: var(--background-light-color-2);
  }

  &.active {
    background: var(--primary-color);
    border-color: var(--primary-color);
    color: white;
  }
`;

export default FilterButtons;
